export default __webpack_public_path__ + "static/media/label_soon.2e6a84b3.svg";